<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.menuType"
        placeholder="菜单类型"
      >
        <el-option
          v-for="(item, i) in menuType"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.menuName"
        placeholder="菜单名称/上级菜单"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" :title="'查询'" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
    <!-- <el-form-item> </el-form-item> -->
  </el-form>
</template>
<script>
import { MENU_STATUS } from "@/utils/constants";
import butn from "@/components/button/index";
import { getDataMap } from "@/api/sysParam";
export default {
  components: {
    butn
  },
  data() {
    return {
      filters: {},
      menuStatus: MENU_STATUS,
      menuType: []
    };
  },
  created() {
    this.getSysParam("MENU_TYPE");
  },
  methods: {
    // 获取数据字典
    getSysParam(param) {
      getDataMap(param).then(res => {
        if (!res || res.code != 0) return;
        res.data.splice(0, 0, {
          paramKey: "",
          paramValue: "全部"
        });
        this.menuType = res.data;
      });
    },
    initData() {
      //查询
      this.$emit("search", this.filters);
    },
    resetData() {
      //重置
      this.filters = {};
      this.$emit("search", {});
    }
  }
};
</script>
